import { Trans } from '@lingui/react/macro'

import { useAudio } from '@/hooks/audio/useAudio'


import { cls } from 'tagged-classnames-free';
interface AudioPreviewProps {
  src: string
  /** 当前试听的标签名 */
  label?: string
}

function AudioPreview(props: AudioPreviewProps) {
  const { src, label } = props
  const audio = useAudio({ src })

  const disabled = !src

  return (
    <div className={cls`flex items-center gap-1`}>
      <div
        className={cls`flex size-6 shrink-0 items-center justify-center rounded-full ${disabled ? 'cursor-default' : 'text-f-primary cursor-pointer'}`}
        onClick={() => {
          if (!disabled) audio.togglePlay()
        }}
      >
        <span
          className={cls`size-6 ${
            disabled
              ? 'i-cus--tad-play-mobile text-f-text-disable'
              : audio.playing
                ? 'i-com--pause'
                : 'i-cus--tad-play-mobile'
          }`}
        />
      </div>
      <span className={cls`text-f-text text-lg font-semibold`}>
        <Trans>Select to preview</Trans>
        {label && (
          <>
            -<span className={cls`text-f-primary`}>{label}</span>
          </>
        )}
      </span>
    </div>
  )
}

export default AudioPreview
